{
  "title": "Filtros de seguimiento de actividad",
  "tooltip": "Estos filtros excluyen FBOs y usuarios de los informes de actividad y métricas.",
  "unknown": "Desconoc.",
  "testFBOs": {
    "sectionTitle": "FBOs de prueba",
    "addButton": "Añadir FBO prueba",
    "columns": {
      "fboName": "Nombre FBO",
      "reason": "Motivo",
      "actions": "Acciones"
    },
    "deleteButton": "Eliminar",
    "dialog": {
      "title": "Añadir FBO de prueba/demo",
      "selectFboLabel": "Seleccionar FBO",
      "reasonLabel": "Motivo (opcional)",
      "reasonPlaceholder": "p. ej., Cuenta de pruebas internas",
      "cancelButton": "Cancelar",
      "addButton": "Añadir"
    }
  },
  "employees": {
    "sectionTitle": "Empleados de AirPlx",
    "addButton": "Añadir empleado",
    "autoExcludedChip": "*@airplx.com (excluido automáticamente)",
    "emptyState": "No hay empleados adicionales configurados (todos los correos @airplx.com se excluyen automáticamente)",
    "dialog": {
      "title": "Añadir empleado de AirPlx",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "user@example.com",
      "cancelButton": "Cancelar",
      "addButton": "Agr."
    }
  }
}
